import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useEffect, useState } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import Restricted from '../../contexts/PermissionProvider/RestrictedWrapper';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import menuDropdownIcon from '../../images/Dropdown Circle.svg';
import { generateFieldId } from '../../utilities/GenerateFieldId';
import Badge from '../badge/badge';
import './menu.css';
import Submenu from './submenu';
import { IAppState } from '@/store/types';
import { useSelector } from 'react-redux';

interface keyable {
    [key: string]: any
}

type MenuProps = {
    menu: any[],
    onClick: (event: any) => void,
    compact: boolean,
    className: string,
    currentPage?: string
}

const Menu: FC<MenuProps> = ({ menu = [], onClick, compact = false, className = '', currentPage }, props) => {
    const [menuItems, setMenuItems] = useState<keyable>(menu.map((item, i) => ({ ...item, selected: false, childSelected: false, open: false })));
    const { translate } = useLocale();
    const { pathname } = useLocation();
    const [isParentRoute, setIsParentRoute] = useState(false);
    const MenuItem = ({ selected = false, onClick, children, compact = false, isCurrent = false, item }) => {
        const selectedBorder = 'border-l-10 border-portal-blue-primary';
        const selectedClass = compact
            ? `py-2 pl-1-5 pr-4 flex flex-col justify-center items-center text-white bg-sidemenu-focus ${selectedBorder}`
            : `py-2 pl-1-5 pr-4 flex flex-row justify-between items-center text-white bg-sidemenu-focus ${selectedBorder}`;
        const defaultClass = compact
            ? 'py-2 px-4 flex flex-col justify-around items-center text-white hover:bg-sidemenu-focus'
            : `py-2 ${item.open ? ' pl-4 pr-4 flex flex-row justify-between' : 'px-4 flex flex-row justify-between'} items-center text-white hover:bg-sidemenu-focus`;

        return (
            <li onClick={onClick} className={selected ? selectedClass : defaultClass}>
                {children}
            </li>
        );
    }
    const permissions = useSelector((state: IAppState) => (state.userInfo.permissions));

    useEffect(() => {
        if (!currentPage) {
            onClick('/' + localStorage.getItem('indexRoute'))
            setMenuItems(menuItems.map(el => el.route === 'enrolment' ? {
                ...el, selected: true, childSelected: true, children:
                [{ ...el.children[0], selected: true }, ...el.children.slice(1)]
            } : { ...el, selected: false, childSelected: false }))
        }

    }, [menuItems, currentPage])

    function handleMenuClick(item, index, event) {
        if (compact) {
            setMenuItems(menuItems => menuItems.map((item, i) => ({
                ...item, selected: index === i, childSelected: false
            })));
            if (!item.showIndexRoute) {
                onClick(`/${item.route}/${item.children[0].route}`);
            } else {
                onClick(`/${item.route}`)
            }
        } else {
            if (event.target.tagName !== 'IMG') {

                if (!item.childSelected && !item.selected || item.showIndexRoute) {
                    onClick(`/${item.route}`)
                    setMenuItems(menuItems.map(el => el.name === item.name ? {
                        ...el,
                        selected: true,
                        childSelected: true
                    }
                        : { ...el, selected: false, childSelected: false }));
                }
                if (!item.showIndexRoute) {
                    const menuItem = menuItems.find(el => el.name === item.name);
                    const firstChildWithAccess = menuItem.children.find(child => permissions?.some(permission => permission.includes(`show.${child.route}.element`)));
                    handleSubmenuClick(index, { ...firstChildWithAccess, selected: false, childSelected: false })
                }
                setMenuItems(menuItems.map(el => el.name === item.name ? {
                    ...el, selected: true, childSelected: true, children:
                    [{ ...el.children[0], selected: false }, ...el.children.slice(1)]
                } : { ...el, selected: false, childSelected: false }))
            }
            else {
                if (item.open) {

                    setMenuItems(menuItems.map(el => el.name === item.name ? {
                        ...el,
                        open: false,
                        selected: false,
                        childSelected: false
                    } : el));
                }
                if (!item.open) {

                    setMenuItems(menuItems.map(el => el.name === item.name ? {
                        ...el,
                        open: true,
                    } : el));
                }
            }

        }
    }

    function handleSubmenuClick(parent, selectedItem) {

        setMenuItems(menuItems => menuItems.map((item, index) => ({
            ...item, selected: false, childSelected: index === parent ? true : false
        })));
        onClick(`/${menuItems[parent].route}/${selectedItem.route}`);

    }

    const isSubmenuVisible = (item) => {
        return item.selected
            || item.childSelected || item.open
    }

    useEffect(() => {
        const currentPathData = pathname.split('/');
        const lastPathIthem = currentPathData.pop();
        const isOnParent = !!menuItems.find(el => el.route === lastPathIthem);
        setIsParentRoute(isOnParent)
    }, [pathname])

    return (
        <div className={`bg-sidemenu-primary ${className}`}>
            <ul>
                {menuItems.map((item, i) => (
                    <Restricted key={`menu${i}`} to={`show.${item.route}.element`}>
                        <React.Fragment key={`menuItem${i}`}>
                            <MenuItem
                                item={item}
                                key={`menuItem${i}`}
                                selected={pathname.includes(`/${item.route}`)}
                                onClick={(event) => handleMenuClick(item, i, event)}
                                compact={compact}
                                isCurrent={currentPage ? item.route === currentPage ? true : false : false}>
                                {compact
                                    ? (
                                        <div className="cursor-pointer flex flex-col text-center items-center">
                                            {item.icon !== null
                                                ? <img src={item.icon} alt="" className="h-6 mx-auto" />
                                                : null
                                            }
                                            <div className="text-xs">{translate.byKey(TranslationKeys[item.translationKey])}</div>
                                        </div>
                                    )
                                    : (
                                        <div className="cursor-pointer flex flex-row flex-grow items-center">
                                            <img src={menuDropdownIcon} alt="" className={`h-7 ${item.selected || item.open ? 'rotate-icon' : ''}`} id={generateFieldId(item.name, 'DropDown')} />
                                            <div className="ml-3 flex flex-row flex-grow justify-between">
                                                <div className="flex flex-row mr-px">
                                                    {item.icon !== null
                                                        ? <img src={item.icon} alt="" className="h-6" />
                                                        : null
                                                    }
                                                    <span className="ml-3 text-base font-medium menu-item" id={generateFieldId(item.name)}>{translate.byKey(TranslationKeys[item.translationKey])}</span>
                                                </div>
                                                {item.badge
                                                    ? <div>
                                                        <Badge fgColor="white" bgColor="sidemenu-badge">{item.badge}</Badge>
                                                    </div>
                                                    : null
                                                }
                                            </div>

                                            {/* Indicate that this main menu has a route of its own and can be loaded. E.g. Hardware, Enrolments, Reports. */}
                                            {item.showIndexRoute
                                            ? (<FontAwesomeIcon icon={faChevronRight} className="mx-2 w-8 menu-item"></FontAwesomeIcon>)
                                            : null}
                                        </div>
                                    )
                                }
                            </MenuItem>
                            {compact === false
                                ? <Submenu currentPage={currentPage} isVisible={isSubmenuVisible(item)} menu={item.children} onClick={handleSubmenuClick} parent={i} isParentRoute={isParentRoute} />
                                : null
                            }
                        </React.Fragment>
                    </Restricted>
                ))}
            </ul>
        </div>
    );
}

export default Menu;
